<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="pb-8">
            <v-btn
              color="primary"
              @click="create = true"
            >Nuova Cam</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
            :items-per-page="-1"
            :footer-props="{
                itemsPerPageAllText: 'Tutte',
                itemsPerPageOptions: [15, 50, 100, -1],
                itemsPerPageText: 'Camere per pagina',
            }"
          >
            <template v-slot:item.edit="{item}">
              <v-btn
                outlined
                color="orange"
                @click="select(item)"
              >Modifica</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      max-width="700px"
      v-model="create"
    >
      <v-card>
        <v-card-title><span class="primary--text"><b>Nuova Camera</b></span></v-card-title>
        <v-card-text>

          <v-text-field
            placeholder="Ordine"
            v-model="cam.order"
          ></v-text-field>
          <v-text-field
            placeholder="Titolo"
            v-model="cam.title"
          ></v-text-field>
          <v-text-field
            placeholder="Url"
            v-model="cam.url"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="insert">
            Aggiungi Camera
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      max-width="700px"
      v-model="edit"
    >
      <v-card>
        <v-card-title><span class="primary--text"><b>Modifica Camera</b></span></v-card-title>
        <v-card-text>

          <v-text-field
            placeholder="Ordine"
            v-model="selected.order"
          ></v-text-field>
          <v-text-field
            placeholder="Titolo"
            v-model="selected.title"
          ></v-text-field>
          <v-text-field
            placeholder="Url"
            v-model="selected.url"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="update">
            Salva Modifiche
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Cams',

    data() {
      return {
        search: null,
        items: [],
        headers: [
          { text: 'Ordine', value: 'order', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Titolo', value: 'title', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Url', value: 'url', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: '', value: 'edit' },
        ],
        create: false,
        edit: false,
        cam: {
          order: null,
          title: null,
          url: null
        },
        selected: {
          order: null,
          title: null,
          url: null
        }
      }
    },

    methods: {
      async fetch() {
        let {
          data
        } = await axios.get(`${process.env.VUE_APP_API}/cams/fetch`)

        this.items = data
      },

      async insert() {
        await axios.post(`${process.env.VUE_APP_API}/cams/insert`, this.cam)

        this.cam = {
          order: null,
          title: null,
          url: null
        }

        this.create = false
        this.fetch()
      },

      async update() {
        await axios.post(`${process.env.VUE_APP_API}/cams/update`, this.selected)

        this.selected = {
          order: null,
          title: null,
          url: null
        }

        this.edit = false
        this.fetch()
      },

      select(cam) {
        this.edit = true
        this.selected = cam
      }

    },

    mounted() {
      this.fetch()
    }
  }
</script>

<style>
</style>